import { z } from 'zod'

export const emailNotificationPreferenceSchema = z.enum(['daily', 'weekly', 'none'])

export const patchEmailNotificationSchema = z.object({
  email_notification: emailNotificationPreferenceSchema,
})

export type EmailNotificationPreference = z.infer<typeof emailNotificationPreferenceSchema>
